/* tslint:disable */
/* eslint-disable */
/**
 * Melco ControlCenter APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ControlcenterMelcoModelsCustomWarning,
    ControlcenterMelcoModelsCustomWarningFromJSON,
    ControlcenterMelcoModelsCustomWarningFromJSONTyped,
    ControlcenterMelcoModelsCustomWarningToJSON,
    ControlcenterMelcoModelsMachineLicensePricingInfo,
    ControlcenterMelcoModelsMachineLicensePricingInfoFromJSON,
    ControlcenterMelcoModelsMachineLicensePricingInfoFromJSONTyped,
    ControlcenterMelcoModelsMachineLicensePricingInfoToJSON,
} from './';

/**
 * 
 * @export
 * @interface ControlcenterMelcoModelsMachineLicense
 */
export interface ControlcenterMelcoModelsMachineLicense {
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsMachineLicense
     */
    product_code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsMachineLicense
     */
    email_address?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsMachineLicense
     */
    license_key?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoModelsMachineLicense
     */
    number_of_machines?: number;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsMachineLicense
     */
    sub_type?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ControlcenterMelcoModelsMachineLicense
     */
    sub_started_on?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof ControlcenterMelcoModelsMachineLicense
     */
    is_validate_only?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsMachineLicense
     */
    language?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsMachineLicense
     */
    transaction_id?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoModelsMachineLicense
     */
    subscription_cost?: number | null;
    /**
     * 
     * @type {ControlcenterMelcoModelsMachineLicensePricingInfo}
     * @memberof ControlcenterMelcoModelsMachineLicense
     */
    monthly?: ControlcenterMelcoModelsMachineLicensePricingInfo;
    /**
     * 
     * @type {ControlcenterMelcoModelsMachineLicensePricingInfo}
     * @memberof ControlcenterMelcoModelsMachineLicense
     */
    yearly?: ControlcenterMelcoModelsMachineLicensePricingInfo;
    /**
     * 
     * @type {Array<ControlcenterMelcoModelsCustomWarning>}
     * @memberof ControlcenterMelcoModelsMachineLicense
     */
    warning_list?: Array<ControlcenterMelcoModelsCustomWarning> | null;
}

export function ControlcenterMelcoModelsMachineLicenseFromJSON(json: any): ControlcenterMelcoModelsMachineLicense {
    return ControlcenterMelcoModelsMachineLicenseFromJSONTyped(json, false);
}

export function ControlcenterMelcoModelsMachineLicenseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlcenterMelcoModelsMachineLicense {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'product_code': !exists(json, 'product_code') ? undefined : json['product_code'],
        'email_address': !exists(json, 'email_address') ? undefined : json['email_address'],
        'license_key': !exists(json, 'license_key') ? undefined : json['license_key'],
        'number_of_machines': !exists(json, 'number_of_machines') ? undefined : json['number_of_machines'],
        'sub_type': !exists(json, 'sub_type') ? undefined : json['sub_type'],
        'sub_started_on': !exists(json, 'sub_started_on') ? undefined : (json['sub_started_on'] === null ? null : new Date(json['sub_started_on'])),
        'is_validate_only': !exists(json, 'is_validate_only') ? undefined : json['is_validate_only'],
        'language': !exists(json, 'language') ? undefined : json['language'],
        'transaction_id': !exists(json, 'transaction_id') ? undefined : json['transaction_id'],
        'subscription_cost': !exists(json, 'subscription_cost') ? undefined : json['subscription_cost'],
        'monthly': !exists(json, 'monthly') ? undefined : ControlcenterMelcoModelsMachineLicensePricingInfoFromJSON(json['monthly']),
        'yearly': !exists(json, 'yearly') ? undefined : ControlcenterMelcoModelsMachineLicensePricingInfoFromJSON(json['yearly']),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(ControlcenterMelcoModelsCustomWarningFromJSON)),
    };
}

export function ControlcenterMelcoModelsMachineLicenseToJSON(value?: ControlcenterMelcoModelsMachineLicense | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'product_code': value.product_code,
        'email_address': value.email_address,
        'license_key': value.license_key,
        'number_of_machines': value.number_of_machines,
        'sub_type': value.sub_type,
        'sub_started_on': value.sub_started_on === undefined ? undefined : (value.sub_started_on === null ? null : value.sub_started_on.toISOString()),
        'is_validate_only': value.is_validate_only,
        'language': value.language,
        'transaction_id': value.transaction_id,
        'subscription_cost': value.subscription_cost,
        'monthly': ControlcenterMelcoModelsMachineLicensePricingInfoToJSON(value.monthly),
        'yearly': ControlcenterMelcoModelsMachineLicensePricingInfoToJSON(value.yearly),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(ControlcenterMelcoModelsCustomWarningToJSON)),
    };
}


